// Screensaver
//--------------------

(function ($) {
    const $body = $('body'),
        $inBackend = $body.hasClass('neos-backend');

    if (!$inBackend) {
        const manualTimeout = parseInt($('body').data('screensaver-timeout')) * 1000,
            defaultTimeout = 10 * 60 * 1000; // default timeout in milliseconds
            // defaultTimeout = 1000; // timeout test setting

        window.addEventListener('load',function () {
            let timeoutId = null;
            let timeout = manualTimeout > 0 ? manualTimeout : defaultTimeout;

            function disable() {
                $body.removeClass('screensaver-active');
                timeoutId && clearTimeout(timeoutId);
                timeoutId = setTimeout(function () {
                    $body.addClass('screensaver-active');
                }, timeout);
            }

            disable();
            document.addEventListener('mousemove', disable);
            document.addEventListener('keydown', disable);
            document.addEventListener('scroll', disable);
        },
        {
            once: true
        });
    }
})(jQuery);
